import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle, ShoppingBag } from 'lucide-react';
import PageHeading from '../components/PageHeading';

export default function OrderSuccess() {
  const { state } = useLocation();
  const { orderId, product, quantity, totalPrice } = state || {};
  return (
    <div className="page-shell max-w-3xl">
      <PageHeading Icon={orderId ? CheckCircle : ShoppingBag} eyebrow="ORDER · 购买结果" title={orderId ? '支付成功' : '查看你的订单'} description={orderId ? '下一步，打开订单详情领取交付内容。' : '此页面暂无订单信息，可从历史订单继续查询。'} />
      {orderId && <div className="page-card mb-5">
        <h2 className="text-lg font-bold mb-4">订单信息</h2>
        {[['订单号', orderId], ['产品', product?.name || '以订单详情为准'], ['数量', quantity || 1], ['支付金额', totalPrice != null ? `¥${totalPrice}` : '以订单详情为准']].map(([label, value]) => <div key={label} className="flex justify-between gap-6 py-3 border-b border-line last:border-0 text-sm"><span className="text-muted shrink-0">{label}</span><strong className="text-right break-all">{value}</strong></div>)}
      </div>}
      <div className="page-card">
        <h2 className="text-xl font-bold mb-3">卡密、账号、网页入口，都在订单里</h2>
        <p className="text-sm text-muted mb-6">按订单指引激活订阅或打开网页入口。需要 Invoice，可联系右下角客服免费领取。</p>
        <div className="flex flex-wrap gap-3"><Link to={orderId ? `/detail/plus-upgrade?orderId=${encodeURIComponent(orderId)}` : '/orders'} className="brand-purchase">查看订单{orderId ? '详情' : ''}</Link><Link to="/" className="page-secondary">返回首页</Link></div>
      </div>
    </div>
  );
}
